class FlixSlider extends HTMLElement {
  connectedCallback() {
    this._track = this.querySelector('[data-flix-slider-track]');
    if (!this._track) return;
    this._prev = this.querySelector('[data-flix-slider-prev]');
    this._next = this.querySelector('[data-flix-slider-next]');
    this._paused = false;
    if (this._prev) this._prev.addEventListener('click', () => this._scroll(-1));
    if (this._next) this._next.addEventListener('click', () => this._scroll(1));
    this._track.addEventListener('mouseenter', () => { this._paused = true; });
    this._track.addEventListener('mouseleave', () => { this._paused = false; });
    this._interval = setInterval(() => this._auto(), 2500);
  }

  disconnectedCallback() {
    clearInterval(this._interval);
  }

  _isRtl() {
    return document.documentElement.getAttribute('dir') === 'rtl';
  }

  _cardWidth() {
    const card = this._track.querySelector(':scope > *');
    return card ? card.offsetWidth + 16 : 240;
  }

  _scroll(dir) {
    const amt = (this._isRtl() ? -1 : 1) * dir * this._cardWidth();
    try { this._track.scrollBy({ left: amt, behavior: 'smooth' }); }
    catch (e) { this._track.scrollLeft += amt; }
  }

  _auto() {
    if (this._paused || !document.contains(this._track)) return;
    const w = this._cardWidth();
    const maxScroll = this._track.scrollWidth - this._track.clientWidth;
    const atEnd = this._isRtl()
      ? this._track.scrollLeft <= -maxScroll + 2
      : this._track.scrollLeft >= maxScroll - 2;
    if (atEnd) this._track.scrollTo({ left: 0, behavior: 'smooth' });
    else this._track.scrollBy({ left: this._isRtl() ? -w : w, behavior: 'smooth' });
  }
}
customElements.define('flix-slider', FlixSlider);
